export const JOB_STATES = Object.freeze({
  AWAITING: "AWAITING",
  SCHEDULED: "SCHEDULED",
  ENQUEUED: "ENQUEUED",
  PROCESSING: "PROCESSING",
  PROCESSED: "PROCESSED",
  FAILED: "FAILED",
  SUCCEEDED: "SUCCEEDED",
  DELETED: "DELETED",
});
